import React, { FC, useMemo, useState } from 'react';
import { AxisOptions, Chart } from 'react-charts';
import { Box } from '@mui/material';
import { IChartData } from './helper';

interface Props {
  data: Array<IChartData>;
}

export const AnalyticsGraph: FC<Props> = ({ data }) => {
  const [activeDatum, setActiveDatum] = useState(-1);

  const primaryAxis = useMemo<AxisOptions<(typeof data)[number]['data'][number]>>(
    () => ({
      getValue: (datum) => data[0]?.data?.length > 10 ? new Date(datum.date.valueOf()) : datum.date.format('MMM DD') as unknown as Date,
      showDatumElements: true,
      show: true,
    }),
    [data],
  );

  const secondaryAxes = useMemo<AxisOptions<(typeof data)[number]['data'][number]>[]>(
    () => [
      {
        getValue: (datum) => datum.views,
        showDatumElements: true,
        elementType: 'area',
        show: true,
      },
    ],
    [data],
  );

  const onFocusDatum = (focused: any) => setActiveDatum(focused ? focused.index : -1);
  const getDatumStyle = (datum: any) => ({
    r: activeDatum === datum.index ? 7 : 3,
    fill: '#fff',
    strokeWidth: activeDatum === datum.index ? 5 : 7,
    color: '#A58450',
  });

  return (
    <Box sx={{ height: `${250}px` }}>
      <Chart
        options={{
          interactionMode: 'closest',
          intersectionObserverRootMargin: '0px 0px 0px 0px',
          data,
          primaryAxis,
          secondaryAxes,
          onFocusDatum,
          getDatumStyle,
          getSeriesStyle: () => ({ fill: '#ebcea0', opacity: 0.8, color: '#A58450' }),
        }}
      />
    </Box>
  );
};
